import React, { useMemo } from 'react'
import { MilkProductionField } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form, Icon, Popup } from 'semantic-ui-react'
import { StyledLabelError } from './style'

const DieselPerCattle:React.FC = () => {
  const { control, formState: { isSubmitted, errors }, clearErrors, setError } = useFormContext()
  
  const watchDieselConsumption = useWatch({ control, name: 'youngCattleDieselConsumption' })
  const watchCattleNumber = useWatch({ control, name: 'youngCattleNumber' })

  const dieselConsPerCowPerYear = useMemo(() => {

    if(watchDieselConsumption && watchCattleNumber) {
      const dieselConsumption = Math.floor(parseFloat(watchDieselConsumption?.toString()?.replace(',', '.')) / watchCattleNumber)
      if(dieselConsumption < 10 || dieselConsumption > 100) {
        setError('dieselCattleConsumption', { message: 'dieselCattleConsumption' })
      } else {
        clearErrors('dieselCattleConsumption')
      }
      return dieselConsumption
    }
        
    return 0
  }, [watchCattleNumber, watchDieselConsumption])

  return <Form.Field>
    <MilkProductionField>
      <label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>{'Liter pro Färse u. Jahr'}</div>
        {(dieselConsPerCowPerYear < 10 || dieselConsPerCowPerYear > 50) && <Popup
          content={'Der Dieselverbrauch pro Färse und Jahr muss mind. 10 Liter und darf max. 50 Liter betragen.'}
          trigger={<Icon name='warning sign' color='yellow' style={{ fontSize: '1.2em' }}/> }
        />}
      </label>
      <div>{`${dieselConsPerCowPerYear} Liter pro Färse u. Jahr`}</div>
    </MilkProductionField>
    {isSubmitted && errors?.dieselCattleConsumption && <StyledLabelError
      prompt
      pointing={'above'}>{'Der Dieselverbrauch pro Färse und Jahr muss mind. 10 Liter und darf max. 100 Liter betragen.'}
    </StyledLabelError>}
  </Form.Field>
}
export default DieselPerCattle